export default {"src":"/_next/static/media/final_round.ce4d8f63.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};